module.exports = __webpack_public_path__ + "static/media/fan.dedbdced.svg";